import { Component, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from '@rocksoft/cdk';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ToastContainerComponent],
})
export class AppComponent implements OnDestroy {
  title = 'era-cms';
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly oidcSecurityService: OidcSecurityService,
    private router: Router
  ) {
    this.subscriptions.push(
      this.oidcSecurityService.checkAuthMultiple().subscribe(([{ isAuthenticated }]) => {
        if (isAuthenticated) {
          const savedRouteForRedirect = sessionStorage.getItem('redirect');
          if (savedRouteForRedirect) {
            sessionStorage.removeItem('redirect');
            void this.router.navigateByUrl(savedRouteForRedirect);
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
